import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class Slider extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
    Object.assign(this.state, this.calculateSliderDimensions());
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.children !== this.props.children &&
      React.Children.count(prevProps.children) !== React.Children.count(this.props.children)
    ) {
      (() => {
        const state = Object.assign({}, this.state, this.calculateSliderDimensions());
        this.setState(state);
      })();
    }
  }

  calculateSliderDimensions() {
    const { slidesPerView, aspectRatio, paddingBtwnSlides, children } = this.props;
    const windowWidth = 100;
    const numItems = React.Children.count(children);
    const slideWidth = windowWidth / slidesPerView;
    const sliderWidth = numItems * slideWidth;
    const sliderHeight = aspectRatio > 0 ? `${slideWidth / aspectRatio}vw` : 'auto';
    const sliderStyle = {
      width: `${sliderWidth}vw`,
      height: sliderHeight,
      paddingLeft: paddingBtwnSlides,
    };
    const slideStyle = { width: `${slideWidth}vw` };

    /* Non madatory title handling */
    const item = { ...{}, ...this.props.item };
    const { title, desc, repeatedTitle } = item;
    let showTitleH4 = false;
    if (title) {
      showTitleH4 = true;
    }
    /* eslint no-unneeded-ternary: 0 */
    return {
      showTitleInline: desc || repeatedTitle ? true : false,
      slideWidth,
      sliderStyle,
      slideStyle,
      showTitleH4,
    };
    /* Non madatory title handling */
  }

  sliderScroll(scrollEv, minScrollMultiplier) {
    const item = { ...{}, ...this.props.item };
    const { desc, repeatedTitle } = item;
    if (!desc && !repeatedTitle) {
      return;
    }
    const scrolledEl = scrollEv.target;
    const scrolledAmt = scrolledEl.scrollLeft;
    if (scrolledAmt >= 60 * minScrollMultiplier) {
      this.setState({ showTitleInline: false });
    } else {
      this.setState({ showTitleInline: true });
    }
  }

  render() {
    const { showTitleH4, slideWidth, slideStyle, sliderStyle, showTitleInline } = this.state;
    const { children, activeIndex } = this.props;
    const item = { ...{}, ...this.props.item };
    const { title, desc, repeatedTitle, titlePosition, preTitle, items } = item;
    let multiplier = 0;
    if (repeatedTitle) {
      multiplier += 2;
    } else if (desc) {
      multiplier += 1;
    }
    return (
      <div
        className={showTitleH4 || showTitleInline ? 'pos-rel pd-t25' : ''}
        data-testid="container"
      >
        {/* Non madatory title handling */}
        {showTitleH4 && !showTitleInline && (
          <h4
            className="fsp16 roboto-slab mr-b8 pd-l8 pd-r8 pos-abs"
            style={{ textAlign: titlePosition || 'left', top: '0' }}
          >
            <span className="fw400 lh-15" data-testid="preTitle">
              {preTitle}&nbsp;
            </span>
            <span className="lh-16">
              <strong>{title}</strong>
            </span>
          </h4>
        )}
        {showTitleInline && (
          <div
            className="display-flex align-items-center justify-space-around roboto-slab pos-abs"
            style={{
              bottom: '4px',
              zIndex: '-1',
              width: `${slideWidth * multiplier}vw`,
              height: sliderStyle.height,
            }}
          >
            <div>
              <div className="fsp16" data-testid="preTitle">
                {preTitle}
              </div>
              <div className="fsp16">
                <strong>{title}</strong>
              </div>
              <div className="fsp10">{desc}</div>
            </div>
            {repeatedTitle && (
              <div>
                <div className="repeated-title fsp16 fw100">{repeatedTitle}</div>
                <div className="repeated-title fsp16 fw200">{repeatedTitle}</div>
                <div className="repeated-title fsp16 fw300">{repeatedTitle}</div>
                <div className="repeated-title fsp16">{repeatedTitle}</div>
              </div>
            )}
          </div>
        )}
        {/* Non madatory title handling */}
        {/* Main Slider Code */}
        <section
          className="slider-container hide-scrollbar"
          data-testid="slidercontainer"
          style={{
            overflowX: 'scroll',
            paddingLeft: multiplier
              ? `${showTitleInline ? slideWidth * multiplier : slideWidth * (multiplier - 1)}vw`
              : 0,
          }}
          onScroll={event => this.sliderScroll(event, multiplier)}
        >
          <div className="slider display-flex" data-testid="slider" style={sliderStyle}>
            {React.Children.map(children, (childNode, index) => {
              return (
                <div
                  key={`slide-${index}`}
                  className={`slide${activeIndex === index ? ' active ' : ''} ${
                    items && items[index].componentName
                      ? items[index].componentName.replace(/\s+/g, '-').toLowerCase()
                      : ''
                  }`}
                  data-testid="slides"
                  style={slideStyle}
                >
                  {childNode}
                </div>
              );
            })}
          </div>
        </section>
      </div>
    );
  }
}

Slider.propTypes = {
  children: PropTypes.array.isRequired,
  aspectRatio: PropTypes.number,
  slidesPerView: PropTypes.number,
  paddingBtwnSlides: PropTypes.string,
  activeIndex: PropTypes.number,
};

Slider.defaultProps = {
  aspectRatio: 1,
  slidesPerView: 1,
  paddingBtwnSlides: '0px',
};

export default Slider;
